import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime } from '../Univ.js';

function OpCaseSheet(props) {
  const { appt_id } = useParams();
  const [opcaseData, setOpcaseData] = useState([]);
  const [viewPharmData, setViewPharmData] = useState([]);
  const [labview, setLabView] = useState([]);
  const [invview, setInvView] = useState([]);
  const [hospData, setHospData] = useState([]);

  useEffect(() => {
    Promise.all([
      axios.get(baseUrl + 'op-case/' + appt_id),
      axios.get(baseUrl + 'view-hospital/' + userLocation + '/'),
    ])
      .then(function (responses) {
        const opcaseResponse = responses[0];
        const hospitalResponse = responses[1];
        setOpcaseData(opcaseResponse.data);
        setHospData(hospitalResponse.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [appt_id, userLocation]);

  useEffect(() => {
    if (Array.isArray(opcaseData)) {
      const dd = opcaseData.map(row => row.drug_id);

      if (dd !== null) {
        function fetchPharmData1() {
          const drugIds = opcaseData.map(row => row.drug_id?.split(',').map(item => item.trim()));
          drugIds.forEach(drugId => {
            try {
              drugId.forEach(id => {
                axios.get(baseUrl + 'update-indent-use/' + id + '/')
                  .then(function (response) {
                    const data = Object.assign({}, response.data);
                    setViewPharmData(prevData => [...prevData, data]);
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              });
            } catch (error) {
              console.log(error);
            }
          });
        }

        fetchPharmData1();
      }
    }
  }, [opcaseData]);

  useEffect(() => {
    fetchlviewData();
  }, []);

  function fetchlviewData() {
    axios.get(baseUrl + "view-lab/" + appt_id)
      .then(response => {
        setLabView(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
    fetchiviewData();
  }, []);

  function fetchiviewData() {
    axios.get(baseUrl + "view-inv/" + appt_id)
      .then(response => {
        setInvView(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  const handlePrint = () => {
    const printContents = document.getElementById('invoice-print').innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    setTimeout(() => {
      window.location.reload();
    }, 1000);
    document.body.innerHTML = originalContents;
  };

  const cdept = opcaseData.map(row => row.appt.cons.department);

  return (
    <section>
      <div>
        {opcaseData.map((row, index) => (
          <div key={index} id="invoice-print">

            <table rules="rows" cellPadding="3" className="text-justify mt-5" width="100%">
              <thead>
                <tr>
                  {hospData.map((hospital) => (
                    <React.Fragment key={hospital.id}>
                      <td
                        align="right"
                        colSpan="2"
                        style={{
                          borderBottom: '1px solid black',
                          borderTop: '1px solid black',
                          padding: '4px',
                          borderRadius: '25px',
                          color: '#000'
                        }}
                      >
                        <p align="center">
                       <img
  src={hospital.logo}
  alt="Hospital Logo"
  style={{width:"60px", height:"60px", objectFit:"contain"}}
/>
<strong>{hospital.hospital}</strong><br />
                          Address&nbsp;: &nbsp;{hospital.address}&nbsp;&nbsp;&nbsp;-&nbsp;
                          <br />Phone : {hospital.mobile} &nbsp; Email : {hospital.email} &nbsp; <br />
                          Web : {hospital.website}
                        </p>
                      </td>
                    </React.Fragment>
                  ))}
                </tr>
              </thead>

              <tbody
               style={{
                          borderBottom: '1px solid black',
                          borderTop: '1px solid black',
                          padding: '4px',
                          borderRadius: '25px',
                          color: '#000'
                        }}
              >
                <tr>
                  <th className="mx-0 ps-5" rowSpan="10">


                    <font>Weight : {row.weight} Kg</font><br />
                    <font>Height : {row.height} Cm</font><br />
                    <font>BMI : {row.bmi}</font><br />
                    <font>Tempr / Pulse : {row.tempr} / {row.pulse}</font><br />

                    <font>BP Sys/Dia  : {row.bp}</font><br />
                    <font>SPO2 : {row.spo2}</font><br />

                  </th>
                </tr>

                <tr>
                  <th className="mx-5 ps-5">
                  <font>PID : {row.appt.pat.pat_id}</font><br />
                    <font>Name : {row.appt.pat.patient}</font><br />
                    <font>Age/Gender : {row.appt.pat.age}/{row.appt.pat.gender}</font><br />
                    <font>Mobile : {row.appt.pat.mobile}</font><br />
                    <font>Consultant : Dr.{row.appt.cons.consultant}</font><br />
                    <font>Appt Date :&nbsp;{row.add_date}</font><br />

                  </th>
                </tr>
              </tbody>
            </table>

            <div className="table-responsive">
              <table
                className="text-justify mt-4 "
                width="100%"
              >
                <tbody>
                  <tr>
                    <td style={{ borderTop: '1px solid black' }}>

                      <div className="ms-5 mt-3">Complaints : {row.complaints}</div>
                      <div className="ms-5 mt-3">Symptoms : {row.symptom}</div>
                      <div className="ms-5 mt-3">Diagnosis : {row.diagnosis}</div>

                    </td>
                    <td style={{ borderTop: '1px solid black' }}>
                    <div className="ms-5 mt-3">Consulting Notes : {row.examination}</div>
                    <div className="ms-5 mt-3">Allergy : {row.allergy}</div>
                      <div className="ms-5 mt-3">P/H/O : {row.illness}</div>


                    </td>
                  </tr>

                  {cdept == 'EYE' && (
                    <React.Fragment>
                      <tr>
                        <td style={{ border: '1px solid', borderColor: '#2194d9' }}>
                          <div className="ms-5 mt-3">ARD : {row.ard}</div>
                          <div className="ms-5">ARS: {row.ars}</div>
                          <div className="ms-5">K1d: {row.k1d}</div>
                          <div className="ms-5">K1s: {row.k1s}</div>
                        </td>
                        <td style={{ border: '1px solid', borderColor: '#2194d9' }}>
                          <div className="ms-5 mt-3">K2d : {row.k2d}</div>
                          <div className="ms-5">K2s: {row.k2s}</div>
                          <div className="ms-5">PTD: {row.ptd}</div>
                          <div className="ms-5">PTS: {row.pts}</div>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: '1px solid', borderColor: '#2194d9' }}>
                          <div className="ms-5 mt-3">VNUD: {row.vnud}</div>
                          <div className="ms-5">VNUS : {row.vnus}</div>
                          <div className="ms-5">VNPD: {row.vnpd}</div>
                          <div className="ms-5">VNPS: {row.vnps}</div>
                        </td>
                        <td style={{ border: '1px solid', borderColor: '#2194d9' }}>
                          <div className="ms-5 mt-3">PGD: {row.pgd}</div>
                          <div className="ms-5">PGS: {row.pgs}</div>
                          <div className="ms-5">Subjectived: {row.subjectived}</div>
                          <div className="ms-5">Subjectives : {row.subjectives}</div>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: '1px solid', borderColor: '#2194d9' }}>
                          <div className="ms-5 mt-3">Pupild: {row.pupild}</div>
                          <div className="ms-5">Pupils: {row.pupils}</div>
                          <div className="ms-5">Cyclod: {row.cyclod}</div>
                          <div className="ms-5">Cyclos: {row.cyclos}</div>
                        </td>
                        <td style={{ border: '1px solid', borderColor: '#2194d9' }}>
                          <div className="ms-5 mt-3">Remarkd: {row.remarkd}</div>
                          <div className="ms-5">Remarks : {row.remarkss}</div>
                          <div className="ms-5">EOMD : {row.eomd}</div>
                          <div className="ms-5">EOMS : {row.eoms}</div>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: '1px solid', borderColor: '#2194d9' }}>
                          <div className="ms-5 mt-3">SLED: {row.sled}</div>
                          <div className="ms-5">SLES: {row.sles}</div>
                          <div className="ms-5">ATD: {row.atd}</div>
                          <div className="ms-5">ATS : {row.ats}</div>
                        </td>
                      </tr>
                    </React.Fragment>
                  )}
                </tbody>
              </table>
            </div>

            {/* 🧪 Drug Table */}
            {Array.isArray(opcaseData) && opcaseData.length > 0 && (
              <div className="table-responsive mt-4">
                <table className="erp-table-modern">
                  <thead>
                    <tr style={{ backgroundColor: '#1bc5ce', color: 'white' }}>
                      <th>Drug ID</th>
                      <th>Drug Name</th>
                      <th>Dose</th>
                      <th>Freq</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {opcaseData.map((row) => (
                      <tr key={row.id}>
                        <td>{row.drug_id?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
                        <td>
                          {viewPharmData?.length > 0 && row.drug_id?.split(',').map((test, index) => {
                            const pharmData = viewPharmData.find((data) => data.id == test);
                            return (
                              <span key={index}>
                                {pharmData?.product.product}
                                <br />
                              </span>
                            );
                          })}
                        </td>
                        <td>{row.dose?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
                        <td>{row.freq?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
                        <td>{row.remarks?.split(',').map((value, index) => <span key={index}>{value}<br /></span>)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
                <div className="mt-3" style={{ borderTop: '1px solid black' }}>Diet Notes : {row.diet}</div>
                      <div className="mt-3" style={{ borderBottom: '1px solid black' }}>Physio Notes : {row.physio}</div>
            {/* 🧫 Lab Test Table */}
            {Array.isArray(labview) && labview.length > 0 && (
              <React.Fragment>
                <div className="table-responsive mt-4">
                  <table className="erp-table-modern">
                    <thead>
                      <tr style={{ backgroundColor: '#1bc5ce', color: 'white' }}>
                        <th>Test Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {labview.map((labviewData, index) => (
                        <tr key={index}>
                          <td>
                            {labviewData?.lab_test?.split(',').map((test, i) => (
                              <div key={i}>{test.trim()}</div>
                            ))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </React.Fragment>
            )}

            {/* 🧍 Investigation Table */}
            {Array.isArray(invview) && invview.length > 0 && (
              <React.Fragment>
                <div className="table-responsive mt-4">
                  <table className="erp-table-modern">
                    <thead>
                      <tr style={{ backgroundColor: '#1bc5ce', color: 'white' }}>
                        <th>Test Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invview.map((invviewData, index) => (
                        <tr key={index}>
                          <td>
                            {invviewData?.inv_test?.split(',').map((test, i) => (
                              <div key={i}>{test.trim()}</div>
                            ))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </React.Fragment>
            )}

          </div>
        ))}

        {/* Print Button */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="mt-5">
          <button
            style={{
              padding: '5px 20px',
              borderRadius: '10px',
              backgroundColor: '#007bff',
              color: '#fff'
            }}
            onClick={handlePrint}
          >
            Print
          </button>
        </div>
      </div>
    </section>
  );
}

export default OpCaseSheet;
